import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import { getIsOnDemand } from "~/store/selectors/selector.configOptions";

export const RequireOnDemand = ({ children, redirectTo }) => {
  const isOnDemand = useSelector(getIsOnDemand);
  return isOnDemand ? children : <Navigate to={redirectTo} />;
};

RequireOnDemand.propTypes = {
  redirectTo: PropTypes.string,
  children: PropTypes.any,
};

RequireOnDemand.defaultProps = {
  redirectTo: "/not-found",
};
